import { createContext, useContext, createSignal } from "solid-js";

// Define the context type
type MapContextType = {
  isJobsShown: () => boolean;
  toggleJobs: () => void;
  isEduShown: () => boolean;
  toggleEdu: () => void;
  isTravelShown: () => boolean;
  toggleTravel: () => void;
  isThreeShown: () => boolean;
  toggleThree: () => void;
};

// Create the context
const MapContext = createContext<MapContextType>();

// Provide the context
export const MapContextProvider = (props: any) => {
    const [isJobsShown, setIsJobsShown] = createSignal(true);
    const [isEduShown, setIsEduShown] = createSignal(true);
    const [isTravelShown, setIsTravelShown] = createSignal(true);
    const [isThreeShown, setIsThreeShown] = createSignal(true);
    const toggleJobs = () => {
        setIsJobsShown(!isJobsShown());
    }
    const toggleEdu = () => {
        setIsEduShown(!isEduShown());
    }
    const toggleTravel = () => {
        setIsTravelShown(!isTravelShown());
    }
    const toggleThree = () => {
        setIsThreeShown(!isThreeShown());
    }

  return (
    <MapContext.Provider value={{isJobsShown, toggleJobs, isEduShown, toggleEdu, isTravelShown, toggleTravel, isThreeShown, toggleThree}}>
      {props.children}
    </MapContext.Provider>
  );
};

// Custom hook to use the Guestbook context
export const useMapContext = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMapContext must be used within a MapContextProvider");
  }
  return context;
};

